import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';

import type { ErrorBody } from '@swf/core/errors/RequestError';
import useRequest from '@swf/core/hooks/useRequest';
import { select } from '@swf/core/store';
import { handleServerError } from '@swf/poker';

import { ENDPOINTS } from '../../../../constants';
import type { PrizeDistributionData } from '../../../../types';

const useFetchPrize = (scriptId: number): [boolean, PrizeDistributionData?] => {
  const request = useRequest();
  const [loading, setLoading] = useState(true);
  const [prizeData, setPrizeData] = useState<PrizeDistributionData>();
  const isPlayMoney = useSelector(select.currency.isPlayMoney);

  useEffect(() => {
    const handlePrizeData = (scriptId: number) => {
      setLoading(true);

      try {
        request({
          service: ENDPOINTS.prizeDistribution,
          http: true,
          body: {
            isRealMoney: !isPlayMoney,
            scriptId
          },
          method: 'GET'
        })
          .pipe(catchError((err) => of(err)))
          .subscribe({
            next: ({ body }: { body: PrizeDistributionData }) => {
              setLoading(false);
              setPrizeData(body);
            }
          });
      } catch (e) {
        handleServerError(e as ErrorBody);
        setLoading(false);
      }
    };
    handlePrizeData(scriptId);
  }, [isPlayMoney, request, scriptId]);

  return [loading, prizeData];
};

export default useFetchPrize;
